import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ["submitButton"]

  connect() {
    // Auto-submit on form changes for search forms
    this.element.addEventListener('input', this.handleInput.bind(this))
    this.element.addEventListener('change', this.handleChange.bind(this))
    
    // If there's a submit button, update its state
    if (this.hasSubmitButtonTarget) {
      this.updateSubmitButton()
    }
  }

  handleInput(event) {
    // Debounce input events
    clearTimeout(this.inputTimeout)
    this.inputTimeout = setTimeout(() => {
      this.submitForm()
    }, 500)
  }

  handleChange(event) {
    // Submit immediately on select/checkbox changes
    if (event.target.type === 'select-one' || event.target.type === 'checkbox') {
      this.submitForm()
    }
  }

  submitForm() {
    // Use Turbo.visit to ensure proper turbo-stream handling
    const formData = new FormData(this.element)
    const params = new URLSearchParams(formData)
    const url = `${this.element.action}?${params.toString()}`
    
    // Make a fetch request that accepts turbo-stream
    fetch(url, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      if (html.trim()) {
        Turbo.renderStreamMessage(html)
      }
    })
    .catch(error => {
      console.error('Auto-submit error:', error)
    })
  }

  enableSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.updateSubmitButton()
    }
  }

  updateSubmitButton() {
    const form = this.element
    const submitButton = this.submitButtonTarget
    const requiredFields = form.querySelectorAll('input[required], textarea[required], select[required]')
    
    let allValid = true
    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        allValid = false
      }
    })

    submitButton.disabled = !allValid
  }

  submit(event) {
    if (this.hasSubmitButtonTarget) {
      const submitButton = this.submitButtonTarget
      submitButton.disabled = true
      
      // Add loading state
      submitButton.classList.add('opacity-75')
    }
    
    // The form will submit naturally via Turbo
  }
}
